<template>
    <h3>Areas Of Focus</h3>

    <div class="horizontal-separator"></div>

    <template v-if="agency.WhatRecruitedFor">
        <h4>What we recruit for:</h4>
        <p>{{ agency.WhatRecruitedFor }}</p>
    </template>

    <template v-if="agency.WhatNotRecruitedFor">
        <h4>What we don't recruit for:</h4>
        <p>{{ agency.WhatNotRecruitedFor }}</p>
    </template>
    
    <h4>Additional Services:</h4>

    <ul>
        <li v-for="(value,key) in additionalServicesList(this.type,this.services)">
            {{ value }}
        </li>
    </ul>

</template>

<script>

import { mapState, mapGetters } from 'vuex';

export default {
    name: 'AdditionalInfo',
    props: {
        type: {
            type: String,
        },
        services: {
            type: String
        }
    },
    computed: {
        ...mapState('agency', ['parameters', 'agency']),
        ...mapGetters('agency', ['additionalServicesList']),
    },
}
</script>
